<template>
	<div class="switcher" @click="toggle()" :class="{val1: currentStatus == 0, val2: currentStatus == 1}">
		<span class="val blue--text">{{val1}}</span>
		<span class="bar"></span>
		<span class="val blue--text">{{val2}}</span>
	</div>
</template>

<script>

export default {
	props: ['val1','val2','active'],
	data() {
		return {
			currentStatus: false
		}
	},
	mounted() {
		this.currentStatus = this.active ? this.active : 0;
	},
	methods: {
		toggle() {
			this.currentStatus = this.currentStatus == 0? 1 : 0;
			this.$emit('update-value',this.currentStatus);
		}
	}
}
</script>
<style scoped lang="scss">
	.switcher {
		$border-radius: px(40);
		display: flex;
		cursor: pointer;
		border-radius: $border-radius;
		position: relative;
		
		* {
			-webkit-touch-callout: none; /* iOS Safari */
			-webkit-user-select: none; /* Safari */
			-khtml-user-select: none; /* Konqueror HTML */
			-moz-user-select: none; /* Old versions of Firefox */
			-ms-user-select: none; /* Internet Explorer/Edge */
			user-select: none; /* Non-prefixed version, currently */
		}
		span {
			font-size: $xs;
		}

		.bar {
			position: absolute;
			width: 50%;
			height: 100%;
			left: 0;
			border-radius: $border-radius;
			background: #fff;
			transition: all 0.15s;
			z-index: 0;
			left: 0;
			right: auto;
		}

		.val {
			color: var(--blue);
			text-transform: uppercase;
			padding: px(5);
			background: rgba(255,255,255,0.3);
			text-align: center;
			flex-basis: 50%;
			z-index: 1;

			&:first-child {
				border-top-left-radius: $border-radius;
				border-bottom-left-radius: $border-radius;
			}

			&:last-child {
				border-top-right-radius: $border-radius;
				border-bottom-right-radius: $border-radius;
			}
		}

		&.val2  {
			.bar {
				left: 50%;
				right: 0;
			}
		}
	}
</style>